import React, { useState, useEffect } from "react";
import {
  Input,
  Form,
  Col,
  Row,
  Button,
  Switch,
  Spin,
  Tooltip,
  Select,
  Card,
} from "antd";
import { QuestionCircleOutlined, SaveOutlined } from "@ant-design/icons";
import RequestHandler from "util/RequestHandler";
import { defaultValidateMessages } from "./Helper";
import CKEditor from "react-ckeditor-component";

const formItemLayout = {
  labelCol: {
    xs: {
      span: 24,
    },
    sm: {
      span: 12,
    },
  },
  wrapperCol: {
    xs: {
      span: 24,
    },
    sm: {
      span: 16,
    },
  },
};

const FormItemLabelWithTooltip = ({ label, tooltip }) => {
  return (
    <>
      {label}{" "}
      <Tooltip title={tooltip}>
        <QuestionCircleOutlined
          className="gx-text-blue"
          style={{ marginLeft: 5, fontSize: "120%" }}
        />
      </Tooltip>
    </>
  );
};

const TenantParameterUpdateForm = (props) => {
  const [loading, setLoading] = useState(false);
  const [editorContent, setEditorContent] = useState();


  const [form] = Form.useForm();

  const erpDesciptionOptions = [
    {
      value: 0,
      text: "Banka Açıklaması"
    },
    {
      value: 1,
      text: "Erp Açıklaması"
    }
  ];

  useEffect(() => {
    if (props.data) {
      if (props.data.posCollectionDescription) {
        setEditorContent(props.data.posCollectionDescription);
      }
      form.setFieldsValue(props.data);
    }
  }, [props.data]);

  const onFinish = (values) => {
    values.posCollectionDescription = editorContent;

    console.log(values);
    RequestHandler.put("/TenantParameter/UpdateParameters", values).then(
      (response) => {
        setLoading(false);
        if (response.success) {
          form.resetFields();
          if (props.onSuccess) props.onSuccess();
        }
      }
    );
  };

  const onFinishFailed = () => setLoading(false);

  return (
    <Spin spinning={props.loading}>
      <Form
        {...formItemLayout}
        validateMessages={defaultValidateMessages}
        form={form}
        name="TenantParameterUpdate"
        initialValues={{
          remember: true,
        }}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
      >
        <Form.Item name="id" hidden>
          <Input />
        </Form.Item>

        <Row justify="center">
          <Col xs={24} sm={12}>
            <Card
              title="Genel"
              style={{ margin: "10px 0", height: "90%" }}
              className="gx-card"
            >
              <Form.Item
                label={
                  <FormItemLabelWithTooltip
                    label="Sms Onayı Şifresiz/Şifreli"
                    tooltip={
                      <>
                        <p>
                          <strong>Seçenek aktif edilirse:</strong>
                          <ul>
                            <li>
                              Kullanıcılar giriş yaparken tek kullanımlık sms
                              kod kullanır.
                            </li>
                          </ul>
                        </p>
                        <p>
                          <strong>Pasif edilirse:</strong>
                          <ul>
                            <li>
                              Kullanıcılar giriş yaparken tek kullanımlık sms
                              kod kullanmadan devam eder.
                            </li>
                          </ul>
                        </p>
                      </>
                    }
                  />
                }
                name="tenantIsSmsAccess"
                valuePropName="checked"
              >
                <Switch />
              </Form.Item>

              <Form.Item
                label={
                  <FormItemLabelWithTooltip
                    label="Rapor Döviz Kuru Günlük/Anlık"
                    tooltip={
                      <>
                        <p>
                          <strong>Seçenek aktif edilirse:</strong>
                          <ul>
                            <li>
                              Raporlamalarda anlık kur bilgisi kullanılır.
                            </li>
                          </ul>
                        </p>
                        <p>
                          <strong>Pasif edilirse:</strong>
                          <ul>
                            <li>
                              Raporlamalarda günlük kur bilgisi kullanılır.
                            </li>
                          </ul>
                        </p>
                      </>
                    }
                  />
                }
                name="isLiveValue"
                valuePropName="checked"
              >
                <Switch />
              </Form.Item>

              <Form.Item
                label={
                  <FormItemLabelWithTooltip
                    label="Döviz Kuru Alış/Satış"
                    tooltip={
                      <>
                        <p>
                          <strong>Seçenek aktif edilirse:</strong>
                          <ul>
                            <li>Hesaplamalarda alış kur bilgisi kullanılır.</li>
                          </ul>
                        </p>
                        <p>
                          <strong>Pasif edilirse:</strong>
                          <ul>
                            <li>
                              Hesaplamalarda satış kur bilgisi kullanılır.
                            </li>
                          </ul>
                        </p>
                      </>
                    }
                  />
                }
                name="isBuyingOrSellerValue"
                valuePropName="checked"
              >
                <Switch />
              </Form.Item>
            </Card>
          </Col>

          <Col xs={24} sm={12}>
            <Card
              title="Hesap Hareketleri"
              style={{ margin: "10px 0", height: "90%" }}
              className="gx-card"
            >
              <Form.Item
                label={
                  <FormItemLabelWithTooltip
                    label="Hesap Hareketleri Excel (B,A)/(+,-)"
                    tooltip={
                      <>
                        <p>
                          <strong>Seçenek aktif edilirse:</strong>
                          <ul>
                            <li>
                              Hesap Hareketlerinden alınan Excel Tutar alanı
                              '+/-' oluşturulur.
                            </li>
                          </ul>
                        </p>
                        <p>
                          <strong>Pasif edilirse:</strong>
                          <ul>
                            <li>
                              Hesap Hareketlerinden alınan Excel Tutar alanı her
                              zaman pozitif değer döner ve yanında bir alan ile
                              B/A ayrımı yapılır.
                            </li>
                          </ul>
                        </p>
                      </>
                    }
                  />
                }
                name="transactionExcelType"
                valuePropName="checked"
              >
                <Switch />
              </Form.Item>

              <Form.Item
                label={
                  <FormItemLabelWithTooltip
                    label="Hesap Hareketleri Excel İşlem Tarihi Formatı"
                    tooltip={
                      <>
                        <p>
                          <strong>Seçenek aktif edilirse:</strong>
                          <ul>
                            <li>
                            Kullanıcılar hesap hareketi exceli indirirken İşlem Tarihi bilgisi Tarih ve Saat olarak 2 ayrı sütunda indirilir.
                            </li>
                          </ul>
                        </p>
                        <p>
                          <strong>Pasif edilirse:</strong>
                          <ul>
                            <li>
                            Kullanıcılar hesap hareketi exceli indirirken İşlem Tarihi bilgisi tek sütunda indirilir.
                            </li>
                          </ul>
                        </p>
                      </>
                    }
                  />
                }
                name="isTransactionDateSeperateInExcel"
                valuePropName="checked"
              >
                <Switch />
              </Form.Item>

              <Form.Item
                label={
                  <FormItemLabelWithTooltip
                    label="Hesap Hareketleri Excel TL Döviz Cinsi Formatı"
                    tooltip={
                      <>
                        <p>
                          <ul>
                            <li>
                              Hesap Hareketleri Excel Sayfasından alınan
                              Excel'lerde TL Döviz cinsinin formatı seçilen
                              formata göre (TRY / TL) oluşturulur.
                            </li>
                          </ul>
                        </p>
                      </>
                    }
                  />
                }
                name="transactionExcelCurrencyFormat"
              >
                <Select defaultValue={0} style={{ maxWidth: "30%" }}>
                  <Select.Option key={0} value={0}>
                    TRY
                  </Select.Option>
                  <Select.Option key={1} value={1}>
                    TL
                  </Select.Option>
                </Select>
              </Form.Item>

              <Form.Item
                label={
                  <FormItemLabelWithTooltip
                    label="Raporlara Virman İşlemleri Dahil Etme"
                    tooltip={
                      <>
                        <p>
                          <strong>Seçenek aktif edilirse:</strong>
                          <ul>
                            <li>
                              Rapor ekranlarında virman işlemleri dahil edilmez.
                            </li>
                          </ul>
                        </p>
                      </>
                    }
                  />
                }
                name="isExcludeTransferTransactionsOnReport"
                valuePropName="checked"
              >
                <Switch />
              </Form.Item>

              <Form.Item
                label={
                  <FormItemLabelWithTooltip
                    label="Raporlara Vadeli İşlemleri Dahil Etme"
                    tooltip={
                      <>
                        <p>
                          <strong>Seçenek aktif edilirse:</strong>
                          <ul>
                            <li>
                              Rapor ekranlarında vadeli işlemleri dahil edilmez.
                            </li>
                          </ul>
                        </p>
                      </>
                    }
                  />
                }
                name="isExcludeTimeDepositTransactionsOnReport"
                valuePropName="checked"
              >
                <Switch />
              </Form.Item>
            </Card>
          </Col>

          <Col xs={24} sm={12}>
            <Card
              title="B2B"
              style={{ margin: "10px 0", height: "90%" }}
              className="gx-card"
            >
              {!props.data.isNKolay && (
                <Form.Item
                  label={
                    <FormItemLabelWithTooltip
                      label="Pos Komisyonu Bayiye Yansıtma/Yansıt"
                      tooltip={
                        <>
                          <p>
                            <strong>Seçenek aktif edilirse:</strong>
                            <ul>
                              <li>
                                Komisyon tanımları girilen tutara yansıtılır.
                              </li>
                              <li>
                                Komisyon tanımı girilmeyen kuruluşlar için ödeme
                                yapılamaz.
                              </li>
                              <li>
                                Komisyon tanımı girişi yapılan taksit sayıları
                                için ödeme yapılabilir.
                              </li>
                            </ul>
                          </p>
                          <p>
                            <strong>Pasif edilirse:</strong>
                            <ul>
                              <li>
                                Bayi yalnız girişi yapılan tutarı öder. Komisyon
                                yansıtılmaz.
                              </li>
                            </ul>
                          </p>
                        </>
                      }
                    />
                  }
                  name="isPosCollectionCommissionFromDealer"
                  valuePropName="checked"
                >
                  <Switch />
                </Form.Item>
              )}

              <Form.Item
                label={
                  <FormItemLabelWithTooltip
                    label="Pos Tahsilat Komisyon Tablosunu Kullanma/Kullan"
                    tooltip={
                      <>
                        <p>
                          <strong>Seçenek aktif edilirse:</strong>
                          <ul>
                            <li>
                              Komisyon tanımları taksit tablosunda vade farkı
                              gibi yansıtılır.
                            </li>
                            <li>
                              Komisyon tanımı girilmeyen kuruluşlar için ödeme
                              yapılamaz.
                            </li>
                            <li>
                              Komisyon tanımı girişi yapılan taksit sayıları
                              için ödeme yapılabilir.
                            </li>
                          </ul>
                        </p>
                        <p>
                          <strong>Pasif edilirse:</strong>
                          <ul>
                            <li>
                              Bayi yalnız girişi yapılan tutarı öder. Vade farkı
                              yansıtılmaz.
                            </li>
                          </ul>
                        </p>
                      </>
                    }
                  />
                }
                name="useCommissionTableForAvailableInstallment"
                valuePropName="checked"
              >
                <Switch />
              </Form.Item>
              <Form.Item
                label={
                  <FormItemLabelWithTooltip
                    label="Banka ve Taksit Birlikte Seçme/Seç"
                    tooltip={
                      <>
                        <p>
                          <strong>Seçenek aktif edilirse:</strong>
                          <ul>
                            <li>
                              Bayi, banka ve taksit sayısını tek seferde seçerek
                              ödemeyi tamamlar.
                            </li>
                          </ul>
                        </p>
                        <p>
                          <strong>Pasif edilirse:</strong>
                          <ul>
                            <li>
                              Bayi taksit tablosunu görür bankayı ve taksit
                              sayısını ayrı ayrı seçerek ödemeyi tamamlar.
                            </li>
                          </ul>
                        </p>
                      </>
                    }
                  />
                }
                name="isSelectableInstallmentTable"
                valuePropName="checked"
              >
                <Switch />
              </Form.Item>
              <Form.Item
                label={
                  <FormItemLabelWithTooltip
                    label="Pos Tahsilat Ekranı Açıklama"
                    tooltip={
                      <>
                        <p>
                          <strong>Açıklama girilirse:</strong>
                          <ul>
                            <li>
                              Ödeme formu üst kısmında girilen açıklama
                              gösterilir.
                            </li>
                          </ul>
                        </p>
                        <p>
                          <strong>Açıklama girilmezse:</strong>
                          <ul>
                            <li>Herhangi bir açıklama gösterilmez.</li>
                          </ul>
                        </p>
                      </>
                    }
                  />
                }
                name="posCollectionDescription"
                getValueFromEvent={(_, editor) => editor.getData()}
              >
                <CKEditor
                  content={editorContent}
                  events={{
                    change: (e) => setEditorContent(e.editor.getData()),
                  }}
                  config={{
                    toolbarGroups: [
                      { name: "styles", groups: ["styles"] },
                      { name: "colors", groups: ["colors"] },
                      {
                        name: "basicstyles",
                        groups: ["basicstyles", "cleanup"],
                      },
                      "/",
                      {
                        name: "paragraph",
                        groups: [
                          "list",
                          "indent",
                          "blocks",
                          "align",
                          "bidi",
                          "paragraph",
                        ],
                      },
                      { name: "links", groups: ["links"] },
                      "/",
                    ],
                    removeButtons:
                      "Save,NewPage,Preview,Print,Templates,Find,Replace,SelectAll,Scayt,HiddenField,ImageButton,Button,Select,Textarea,TextField,Radio,Checkbox,Form,Flash,Image,About,Strike,Subscript,Superscript,CopyFormatting,RemoveFormat,Cut,Copy,Paste,PasteText,PasteFromWord,Undo,Redo,Source,Table,HorizontalRule,Smiley,SpecialChar,PageBreak,Iframe,Maximize,ShowBlocks,Styles,FontSize,Font,CreateDiv,Blockquote,Language,BidiRtl,BidiLtr,Anchor",
                  }}
                />
              </Form.Item>
              <Form.Item
                label={
                  <FormItemLabelWithTooltip
                    label="Linkle Ödeme Varsayılan Dil Seçeneği"
                    tooltip={
                      <>
                        <p>
                          <ul>
                            <li>
                              Linkle ödeme sayfası için varsayılan dil
                              seçeneğini belirleyebilirsiniz.
                            </li>
                          </ul>
                        </p>
                      </>
                    }
                  />
                }
                name="b2BPayWithLinkDefaultLanguageOption"
              >
                <Select defaultValue={0} style={{ maxWidth: "30%" }}>
                  <Select.Option key={0} value={0}>
                    Türkçe
                  </Select.Option>
                  <Select.Option key={1} value={1}>
                    İngilizce
                  </Select.Option>
                </Select>
              </Form.Item>
              <br></br>
            </Card>
          </Col>

          <Col xs={24} sm={12}>
            <Card
              title="ERP"
              style={{ margin: "10px 0", height: "90%" }}
              className="gx-card"
            >
              <Form.Item
                label={
                  <FormItemLabelWithTooltip
                    label="Erp Aktarım sonrası Kural Ekleme"
                    tooltip={
                      <>
                        <p>
                          <strong>Seçenek aktif edilirse:</strong>
                          <ul>
                            <li>
                              Erp'ye Aktar butonuna basılıp İşlem Başarılı
                              olduğunda, sistem otomatik olarak eklenebilecek
                              kuralları listeler.
                            </li>
                          </ul>
                        </p>
                      </>
                    }
                  />
                }
                name="useMultipleRuleAddOnErp"
                valuePropName="checked"
              >
                <Switch />
              </Form.Item>
              <Form.Item
                label={
                  <FormItemLabelWithTooltip
                    label="Cari Vkn Adet Bilgisi"
                    tooltip={
                      <>
                        <p>
                          <strong>Seçenek aktif edilirse:</strong>
                          <ul>
                            <li>
                              ERP Aktarım ekranında Cari Vkn Adet bilgisi
                              görüntülenir.
                            </li>
                          </ul>
                        </p>
                        <p>
                          <strong>Seçenek Pasif edilirse:</strong>
                          <ul>
                            <li>
                              ERP Aktarım ekranında Cari Vkn Adet bilgisi
                              görüntülenmez.
                            </li>
                          </ul>
                        </p>
                      </>
                    }
                  />
                }
                name="isUseFirmVknCount"
                valuePropName="checked"
              >
                <Switch />
              </Form.Item>

              <Form.Item
                label="Satır Açıklaması"
                name="erpLineDescription"
              >
                <Select defaultValue={0} style={{ maxWidth: "60%" }}>
                  <Select.Option value={null}>Seçiniz</Select.Option>
                  { erpDesciptionOptions.map(x=>
                        <Select.Option key={x.value} value={x.value}>{x.text}</Select.Option>
                    )}
                </Select>
              </Form.Item>

              <Form.Item
                label="Fiş Açıklaması"
                name="erpReceiptDescription"
              >
                <Select defaultValue={0} style={{ maxWidth: "60%" }}>
                  <Select.Option value={null}>Seçiniz</Select.Option>
                  { erpDesciptionOptions.map(x=>
                        <Select.Option key={x.value} value={x.value}>{x.text}</Select.Option>
                    )}
                </Select>
              </Form.Item>
            </Card>
          </Col>
        </Row>

        <Row>
          <Col span={24}>
            <Col style={{ textAlign: "right" }}>
              <Button
                type="primary"
                icon={<SaveOutlined />}
                htmlType="submit"
                onClick={() => setLoading(true)}
                loading={loading}
              >
                Kaydet
              </Button>
            </Col>
          </Col>
        </Row>
      </Form>
    </Spin>
  );
};
export default TenantParameterUpdateForm;
